import { render, staticRenderFns } from "./PocField.vue?vue&type=template&id=24a42464&scoped=true"
import script from "./PocField.vue?vue&type=script&lang=js"
export * from "./PocField.vue?vue&type=script&lang=js"
import style0 from "./PocField.vue?vue&type=style&index=0&id=24a42464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a42464",
  null
  
)

export default component.exports